import { render, staticRenderFns } from "./OntslagbriefBase.vue?vue&type=template&id=2ab97bb8"
import script from "./OntslagbriefBase.vue?vue&type=script&lang=js"
export * from "./OntslagbriefBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports